// Metric Keys
export const MetricKeys = {
  impressions: "impressions",
  tgImpressions: "tgImpressions",
  reach: "reach",
  tgReach: "tgReach",
  frequency: "frequency",
};

// metrics options for dropdown Items
export const MetricsOptionsDropdownItems = [
  { id: MetricKeys.impressions, label: "Impressions" },
  { id: MetricKeys.tgImpressions, label: "TG-Impressions" },
  { id: MetricKeys.reach, label: "Reach" },
  { id: MetricKeys.tgReach, label: "TG-Reach" },
  { id: MetricKeys.frequency, label: "Frequency" },
];

// chart data keys
export const MetricsPieChartDataKeys = [{ dataKey: "value" }];
export const ImpressionsSplitBarDataKeys = [
  { dataKey: "Impressions" },
  { dataKey: "TG Impressions" },
];
export const ReachSplitBarDataKeys = [
  { dataKey: "Reach" },
  { dataKey: "TG Reach" },
];
export const GenderRatioBarDataKeys = [
  { dataKey: "Male" },
  { dataKey: "Female" },
];
export const AgeSplitBarDataKeys = [
  { dataKey: "Age(%) Below-18" },
  { dataKey: "Age(%) 18-34" },
  { dataKey: "Age(%) 35-44" },
  { dataKey: "Age(%) 45-Above" },
];

// graph report pie chart data sections limit
export const GraphReportPieChartCityLimit = 10;
